export const billingToDeliveryDate = (billingDate, offsetDays) => {
	const deliveryDate = new Date(billingDate);
	deliveryDate.setDate(deliveryDate.getDate() + offsetDays);
	return `${deliveryDate.toDateString()} ${deliveryDate.toTimeString()}`;
};


export const filterAvailableDates = (date, disabledDatesAndWeekdays, latestOrderDate) => {
	const disabledDates = disabledDatesAndWeekdays.filter(item => Array.isArray(item));
	const disabledDays = disabledDatesAndWeekdays.filter(item => !Array.isArray(item));
	const latestOrderDateObj = new Date(latestOrderDate);

	const isSameDate = (d1, d2) =>
		d1.getFullYear() === d2.getFullYear() &&
		d1.getMonth() === d2.getMonth() &&
		d1.getDate() === d2.getDate();

	if (disabledDates.some(([year, month, day]) => isSameDate(date, new Date(year, month, day))) // Disable specific date
		|| isSameDate(date, latestOrderDateObj) // Disable latest order date
		|| disabledDays.includes(date.getDay() + 1))  // Disable specified weekdays
		return false;

	return true;
};

export const calculateNextBillingDate = ({ intervalType, intervalCount }) => {
	const today = new Date();
	switch (intervalType) {
		case "DAY":
			return today.setDate(today.getDate() + intervalCount);
		case "WEEK":
			return today.setDate(today.getDate() + intervalCount * 7);
		case "MONTH":
			return today.setMonth(today.getMonth() + intervalCount);
		case "YEAR":
			return today.setFullYear(today.getFullYear() + intervalCount);
	}
};
